import { gallery } from './gallery.ts'
import { maker } from './maker.ts'
import { publish } from './publish.ts'
import { report } from './report.ts'

export const marketplace = {
  gallery,
  maker,
  publish,
  report
}
